import { ReactNode } from "react";
import styled from "styled-components";
import Footer from "./home/Footer";
import Navbar from "./home/Navbar";

type StaticPageLayoutProps = {
    children: ReactNode;
};

const StaticPageLayout = ({ children }: StaticPageLayoutProps) => {
    return (
        <PageWrapper>
            <Navbar />
            <Main>{children}</Main>
            <FooterWrap>
                <Footer />
            </FooterWrap>
        </PageWrapper>
    );
};

export default StaticPageLayout;

const PageWrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding-top: 88px;
    position: relative;
    overflow: hidden;
    isolation: isolate;
    background: linear-gradient(180deg, #f3f7ff 0%, #ffffff 45%);

    &::before,
    &::after {
        content: "";
        position: absolute;
        width: 720px;
        height: 720px;
        border-radius: 50%;
        z-index: 0;
        pointer-events: none;
    }

    &::before {
        top: -360px;
        right: -240px;
        background: radial-gradient(
            45% 45% at 50% 50%,
            rgba(16, 121, 255, 0.22) 0%,
            rgba(16, 121, 255, 0) 70%
        );
    }

    &::after {
        bottom: -360px;
        left: -240px;
        background: radial-gradient(
            45% 45% at 50% 50%,
            rgba(72, 186, 255, 0.18) 0%,
            rgba(72, 186, 255, 0) 70%
        );
    }
`;

const Main = styled.main`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 32px 20px 60px;
    position: relative;
    z-index: 1;
    flex: 1;
`;

const FooterWrap = styled.div`
    position: relative;
    z-index: 1;
`;
